import Vue from "vue";
import Vuex from "vuex";
import { logout} from '@/api/login'
import { clearMerchantInfo } from '@/utils/merchant'
Vue.use(Vuex);



export default new Vuex.Store({
  state: {
   goodsForm:{},
   goodsDetails:{},
   token:'11',
  //  leastCartLimit:'',
   // clearing:''
   // goodsCar:[], //商品加入到本地
  },
  mutations: {
 // SET_TOKEN: (state, token) => {
 //   state.token = token
 // },
 SET_GOODSFORM: (state, formData) => {
  state.goodsForm = formData;
 },
 SET_GOODSDETAILS: (state, detail) => {
  state.goodsDetails = detail;
 }
  },
  getters: {

      //get方法
          getGoodsForm: state => state.goodsForm

  },
  actions: {
   // 登录
   Login({ commit }, userInfo) {
     return new Promise((resolve, reject) => {
       login(userInfo).then(res => {
		   setToken(res.token)
         // commit('SET_TOKEN', res.token)
         resolve()
       }).catch(error => {
         reject(error)
       })
     })
   },
   // 退出系统
   LogOut({ commit, state }) {
     return new Promise((resolve, reject) => {
       logout().then(() => {
         // commit('SET_TOKEN', '')
          localStorage.removeItem('clientToken')
          // 退出 / 401 登录失效时清掉商户缓存，避免下次登录残留上一次的 merchantId
          clearMerchantInfo()
          location.href = '/';
	        resolve()
	      }).catch(error => {
          // 退出接口失败同样清理商户缓存
          clearMerchantInfo()
	        reject(error)
	      })
	    })
	  },
    //页面到顶
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0
    }
  },
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js